'use client';

import type { ReactElement } from 'react';
import { useContext } from 'react';
import type { NodeProps } from '@xyflow/react';
import { TreemapNodeKind, type TreemapFlowNode } from './treemap-types';
import { TreemapHoverContext } from './treemap-hover-context';
import { TreemapLeafCell } from './TreemapLeafCell';
import { TreemapSectionCell } from './TreemapSectionCell';
import { getTreemapCellNodeModel } from './treemap-cell-node-model';

export function TreemapCellNode({
  data,
  width,
  height,
}: NodeProps<TreemapFlowNode>): ReactElement {
  const { hoveredNodeId, activeNodeIds } = useContext(TreemapHoverContext);
  const model = getTreemapCellNodeModel({
    data,
    width,
    height,
    hoveredNodeId,
    activeNodeIds,
  });

  if (model.kind === TreemapNodeKind.Section) {
    return <TreemapSectionCell model={model} />;
  }

  return <TreemapLeafCell model={model} />;
}
